import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit';
import { ContentLoading } from '../ContentLoading';
import * as styles from './styles.css';
import { ILocation } from '../../../../../types/location';
import { ErrorBoundary } from '../ErrorBoundary';
import { SpecialRegionsDesktop } from '../SpecialRegionsDesktop';
import { PopularRegionsDesktop } from '../PopularRegionsDesktop';

export interface IGeoLocationModalDesktopProps {
  /** Заголовок окна **/
  title: string;
  /** Компонент поиска **/
  searchComponent: React.ReactNode;
  /** Модальное окно открыто **/
  isOpen: boolean;
  /** Данные в процессе загрузки **/
  isLoading?: boolean;
  /** Ошибка загрузки **/
  isError?: boolean;
  /** Популярные регионы **/
  specialRegions?: ILocation[];
  /** Все доступные регионы **/
  locations?: ILocation[];
  /** Текущий выбранный регион **/
  selectedLocation: ILocation;

  onClose(): void;
  onRetry(): void;
  onLocationSelect(location: ILocation): void;
}

export const GeoLocationModalDesktop: React.FC<IGeoLocationModalDesktopProps> = props => {
  const {
    searchComponent,
    isOpen,
    onClose,
    locations,
    specialRegions,
    onLocationSelect,
    isLoading,
    selectedLocation,
    title,
    onRetry,
    isError,
  } = props;

  return (
    <ModalWindow open={isOpen} onClose={onClose} title={title} width={928}>
      <div className={styles['search']}>{searchComponent}</div>
      <div className={styles['content']}>
        {isError && <ErrorBoundary onClick={onRetry} />}
        <ContentLoading isLoading={isLoading}>
          {specialRegions && (
            <SpecialRegionsDesktop
              onLocationSelect={onLocationSelect}
              locations={specialRegions}
              selectedLocationId={selectedLocation.id}
            />
          )}
          {locations && (
            <PopularRegionsDesktop
              onLocationSelect={onLocationSelect}
              locations={locations}
              selectedLocationId={selectedLocation.id}
            />
          )}
        </ContentLoading>
      </div>
    </ModalWindow>
  );
};

GeoLocationModalDesktop.displayName = 'GeoLocationModalDesktop';
